import { render, staticRenderFns } from "./PaymentMethodCard.vue?vue&type=template&id=0279ef94&"
import script from "./PaymentMethodCard.vue?vue&type=script&lang=js&"
export * from "./PaymentMethodCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports